import React from 'react';
import { BORDER, TEXT_MUTED, TEXT_PRIMARY } from './tokens';

/**
 * Empty state.
 *
 * Seven copies across the module, five of them identical and two that had
 * drifted (CallHistory lost its background and radius; TrunkManagement and
 * RateCards used a smaller variant for nested lists).
 *
 * Dashed border rather than a filled panel: an empty region should read as a
 * placeholder, not as content.
 */
const EmptyState = ({ icon: Icon, title, description, action, size = 'md' }) => {
  const pad = size === 'sm' ? 'py-8' : 'py-14';
  const iconSize = size === 'sm' ? 'w-8 h-8' : 'w-10 h-10';

  return (
    <div className={`text-center ${pad} px-6 rounded-xl border border-dashed ${BORDER}`}>
      {Icon && <Icon className={`mx-auto ${iconSize} text-gray-300 dark:text-gray-600`} />}
      <h3 className={`mt-3 text-sm font-medium ${TEXT_PRIMARY}`}>{title}</h3>
      {description && (
        <p className={`mt-1 text-[13px] max-w-sm mx-auto ${TEXT_MUTED}`}>{description}</p>
      )}
      {action && <div className="mt-4 flex justify-center">{action}</div>}
    </div>
  );
};

export default EmptyState;
